import {
  getServiceTopics,
  getServiceTopicsOfSchool,
  getServiceTopicsOfParentSchools
} from "@/api/service_topic";
import { ServiceTopic } from "@/entities/service_topic";
import { Module } from "vuex";
import { RootState } from "..";

interface ServiceTopicState {
  initialized: boolean;
  serviceTopics: ServiceTopic[];
  serviceTopicsForSchoolAI: ServiceTopic[];
  serviceTopicsOfSchool: ServiceTopic[];
  serviceTopicsOfParentSchools: ServiceTopic[];
}

const roomModule: Module<ServiceTopicState, RootState> = {
  namespaced: true,

  state: {
    initialized: false,
    serviceTopics: [],
    serviceTopicsForSchoolAI: [],
    serviceTopicsOfSchool: [],
    serviceTopicsOfParentSchools: []
  },

  getters: {},

  mutations: {
    INITIALIZE(state) {
      state.initialized = true;
    },
    SET_SERVICE_TOPICS(state, serviceTopics: ServiceTopic[]) {
      state.serviceTopics = serviceTopics;
    },
    SET_SERVICE_TOPICS_FOR_SCHOOL_AI(state, serviceTopics: ServiceTopic[]) {
      state.serviceTopicsForSchoolAI = serviceTopics;
    },
    SET_SERVICE_TOPICS_OF_SCHOOL(state, serviceTopics: ServiceTopic[]) {
      state.serviceTopicsOfSchool = serviceTopics;
    },
    SET_SERVICE_TOPICS_OF_PARENT_SCHOOLS(state, serviceTopics: ServiceTopic[]) {
      state.serviceTopicsOfParentSchools = serviceTopics;
    },
    CLEAR(state) {
      state.initialized = false;
      state.serviceTopics = [];
    }
  },

  actions: {
    async setup(context) {
      if (context.state.initialized) {
        return;
      }
      const [
        serviceTopics,
        serviceTopicsForSchoolAI,
        serviceTopicsOfSchool,
        serviceTopicsOfParentSchools
      ] = await Promise.all([
        getServiceTopics({ toSchoolAIUser: false }),
        getServiceTopics({
          toSchoolAIUser: true
        }),
        getServiceTopicsOfSchool(),
        getServiceTopicsOfParentSchools(
          context.rootState.schoolConfig?.data.parentSchoolDocIds ?? []
        )
      ]);

      context.commit("SET_SERVICE_TOPICS", serviceTopics);
      context.commit(
        "SET_SERVICE_TOPICS_FOR_SCHOOL_AI",
        serviceTopicsForSchoolAI
      );
      context.commit("SET_SERVICE_TOPICS_OF_SCHOOL", serviceTopicsOfSchool);
      context.commit(
        "SET_SERVICE_TOPICS_OF_PARENT_SCHOOLS",
        serviceTopicsOfParentSchools
      );
      context.commit("INITIALIZE");
    }
  }
};

export default roomModule;
